import { Image, Text } from '@wix/design-system';
import React, { FC } from 'react';
import styles from './ProductCard.scss';
import { CartSmall } from '@wix/wix-ui-icons-common';

type Props = {
  imageUrl: string;
  name: string;
  buyButtonText: string;
};

export const ProductCard: FC<Props> = ({ imageUrl, name, buyButtonText }) => {
  return (
    <div className={styles.productCard}>
      <div className={styles.productCardImageWrapper}>
        <Image transparent className={styles.productCardImage} src={imageUrl} />
      </div>
      <div className={styles.productCardContent}>
        <Text size="tiny" weight="bold">
          {name}
        </Text>
        <div className={styles.productCardBuyButton}>
          <CartSmall />
          <span>{buyButtonText}</span>
        </div>
      </div>
    </div>
  );
};
